import { APPROVAL_TYPES } from 'lib/api/approvals/types';
import SharedApprovalsDrawer from 'pages/mobile/Finance/shared/drawers/ApprovalsDrawer';
import React from 'react';

import { useFactoringOperationDetail } from '../context';

const ApprovalsDrawer: React.FC = () => {
  const { quoteId, requestId } = useFactoringOperationDetail();
  const approvalPath =
    requestId != null && requestId !== ''
      ? `/finance/factoring/${requestId}/approval`
      : '';

  return (
    <SharedApprovalsDrawer
      approvalType={APPROVAL_TYPES.FACTORING_QUOTE}
      entityId={quoteId}
      requestId={requestId}
      approvalPath={approvalPath}
      buildApprovalState={(type, userRoles) => ({
        type,
        quoteId: quoteId ?? undefined,
        userRoles,
      })}
    />
  );
};

export default ApprovalsDrawer;
